import { Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  ProjectsFacade,
  setDelayedFlag,
  nonNegativeValidator,
  debounce,
  formatNumber,
  onKeyDown,
  getRolesAndPermission,
} from '@piqet-angular/data';
import {
  AccessPermissionService,
  CustomModalService,
  DistanceTypeEnum,
  commonEnum,
  mainModuleName,
  noOfTripsErr,
  percentReuseEOLerr,
  rolesModuleName,
} from '@piqet-angular/shared';
import { CustomService } from 'libs/data/src/lib/services/custom/custom.service';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { GridIconComponent } from '../grid-icon/grid-icon.component';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { MapsAPILoader } from '@agm/core';
import { Observable, Subject, Subscription, first, forkJoin, take } from 'rxjs';
import { ProjectPackEOLDataGridService } from 'libs/features/src/lib/layout/projects/project-details/project-scenario-eol/project-scenario-eol-data-grid.service';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { GridCellRendererComponent } from '../grid-cell-renderer/grid-cell-renderer.component';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'piqet-angular-new-eol-pre-retail',
  templateUrl: './new-eol-pre-retail.component.html',
  styleUrls: ['./new-eol-pre-retail.component.scss'],
})
export class NewEolPreRetailComponent implements OnDestroy {
  noOfTripsErr = noOfTripsErr;
  percentReuseEOLerr = percentReuseEOLerr;
  pageNumber: number = 1;
  searchValue: any;
  selectedCities: any;
  modalLabel: any = 'Add reuse data';
  eolPreRetrailForm!: FormGroup;
  reuseProcessDetailForm: any;
  transportationDetailForm: any;
  distanceBlack = './assets/icons/BasedOnDistance.png';
  distanceWhite = './assets/icons/BasedOnDistanceWhite.png';
  locationBlack = './assets/icons/BasedOnLocations.png';
  loactionWhite = './assets/icons/BasedOnLocationsWhite.png';
  customBlack = './assets/icons/CustomScenarios.png';
  customWhite = './assets/icons/CustomScenariosWhite.png';
  wholeData: any = [
    {
      displayName: 'Based on locations',
      img: this.locationBlack,
      widthImg: 19,
      heightImg: 26,
      type: 'location',
      transportaionId: 2,
    },
    {
      displayName: 'Based on distances',
      img: this.distanceBlack,
      widthImg: 26,
      heightImg: 25,
      type: 'distance',
      transportaionId: 3,
    },
    {
      displayName: 'Custom freight scenarios',
      img: this.customBlack,
      widthImg: 22,
      heightImg: 26,
      type: 'custom',
      transportaionId: 4,
    },
  ];
  selectCustom = false;
  selectDistance = false;
  selectLocation = false;
  selectedBox: any;
  checkHitButton = false;
  isShowCustomTransportList = false;
  transportaionId: any;
  isShowDistantField = false;
  isReusesubmitted = false;
  isCustomReuse = false;
  TransportationEnum = [
    { Description: 'Material Default', id: 1 },
    { Description: 'Manual Locations', display: 'location', id: 2 },
    { Description: 'Manual Distances', display: 'distance', id: 3 },
    { Description: 'Custom Transport Mode', display: 'custom', id: 4 },
  ];
  isCustomTruck = false;
  percenteageMassLoad: any;
  isShowPort = false;
  customTruckItems: any;
  keywordAuto: string = '';
  componenetListItems: any;
  reuseTypeList: any;
  seaDistance: any;
  setManualLocationDis: any;
  isValidPort: any;
  setDestinationsubmitted = false;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
  };
  getEolPreRetailData: any;
  mainAmount: any;
  locationProcessDef: any;
  distanceProcessColumnDef: any;
  customTransportDef: any;
  reuseColumnDef: any;
  activatedRoute: any;
  fromEdit: any;
  gridLoaded = { value: false };
  keyword = 'name';
  originId: any;
  isLoading = false;
  setOriginsubmitted = false;
  transportScenarioData: any = {
    transportModeId: 0,
    transportModeName: '',
    cityName: '',
    distance: '',
    originId: '',
  };
  transportModeItems: any;
  messageType: any;
  transportModeId: any;
  transportModeName: any;
  lastItem: any;
  transportModeDescription: any;
  destinationData: any;
  energyProcessDetailForm: any;
  setManualDistanceSubmitted = false;
  transportScenarioDataForDistance: any;
  customtransportScenarioItems: any;
  CustomtransportScenarioId: any;
  componentSubmitted: any;
  submitted: any;
  transportIcons: any;
  ingredientTransportColumnDef: any;
  energyFillinListiItems: any;
  isTripCheck = false;
  isReuseCheck = false;
  isCostTrunOff = false;
  columnDefsPreretailCost: any;
  reusePayload: any;
  customReuseItems: any;
  pathName: any;
  existReuseProcessItem: any;
  isComponentDetailEdit = false;
  @Output() saveNewPreRetailEvent = new EventEmitter<{ mainPayload: any; pathName: any }>();
  @ViewChild('autoForOrigin') autoForOrigin: any;
  @ViewChild('autoForDestination') autoForDestination: any;
  frameworkComponentsForPreRetailTransport = {
    actionRenderer: ActionButtonComponent,
    iconsOfTransport: GridIconComponent,
    inlineActionButtonComponent: InlineActionButtonComponent,
    GridCellRendererComponent: GridCellRendererComponent,
  };

  tempData: any = [];
  cityWithPort: any;
  setManualLocationDisForNextRecord: any;
  checkIsOrginBtn = true;
  isCheckEditManudalDist = false;
  isCheckUpdateDestination = false;
  isCheckUpdateOrigin = false;
  subscriptionProjectPreRetailData!: Subscription;
  projectPreRetaileditData: any;
  setDestinationLocationData: any;
  getOriginAndDestinationEditData: any;
  subscriptionCheckDeleteRowData!: Subscription;
  subscriptionProjectPreRetailManudalDistanceData!: Subscription;
  projectPreRetaileditManualDistanceData: any;
  setApiResDistance = false;
  subscriptionSaveProjectManualDistanceEOLData!: Subscription;
  clearInputFieldProjectRetailManualDistanceEOL!: Subscription;
  reuseComponentsItemSubscription!: Subscription;
  editReuseProcessItemSubscription!: Subscription;
  saveReuseProcessItemSubscription!: Subscription;
  reuseDeleteComponentsItemSubscription!: Subscription;
  customFreightSelectData: any;
  isConsumer: any;
  customeLocationTransportationItems: any;
  private searchSubject = new Subject<string>();
  private readonly debounceTimeMs = 300; // Set the debounce time (in milliseconds)
  search$!: Observable<string>;
  scenarioId: any;
  showTripErr!: boolean;
  showReuseErr!: boolean;
  isCheckReuseProcessEdit = false;
  isRowEditable = false;
  editComponentItem: any;
  eolValidationMessages =
    "At least one record is required. Please press 'Add Reuse' to add the component to the list before saving.";
  showEdit: boolean = false;
  showCustomReuse: boolean = false;
  showCustomTruckAccess: boolean = false;
  showCustomConversionAccess: boolean = false;
  showCustomTransportAccess: boolean = false;

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    public projectFacde: ProjectsFacade,
    private projectService: ProjectsService,
    private accessService: AccessPermissionService,
    private customService: CustomService,
    private sharedService: SharedService,
    private projectPackEOLDataGridService: ProjectPackEOLDataGridService,
    private mapsAPILoader: MapsAPILoader
  ) {
    this.activatedRoute = this.modal?.modalService?.config?.initialState?.['pathName'];
    this.locationProcessDef =
      this.modal?.modalService?.config?.initialState?.['locationProcessDef'];
    this.distanceProcessColumnDef =
      this.modal?.modalService?.config?.initialState?.['distanceProcessColumnDef'];
    this.customTransportDef =
      this.modal?.modalService?.config?.initialState?.['customTransportDef'];
    this.ingredientTransportColumnDef =
      this.modal?.modalService?.config?.initialState?.['ingredientTransportColumnDef'];
    this.columnDefsPreretailCost =
      this.modal?.modalService?.config?.initialState?.['columnDefsPreretailCost'];
    this.reuseColumnDef = this.modal?.modalService?.config?.initialState?.['reuseColumnDef'];
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.getEolPreRetailData =
      this.modal?.modalService?.config?.initialState?.['newEolPreRetailData'];
    this.isConsumer = this.modal?.modalService?.config?.initialState?.['reuseType'];
    this.scenarioId = this.modal?.modalService?.config?.initialState?.['scenarioId'];
    this.initializeData();
    this.sharedService.disableAddRowBtnTrigger$.subscribe((error: any) => {
      this.checkEditingStatus(error);
    });
  }
  checkEditingStatus(err: any) {
    if (err == 'editingStarted') {
      this.isRowEditable = true;
    } else if (err == 'editingStopped') {
      this.isRowEditable = false;
    }
  }
  async fingOriginAndDestination(x: any) {
    this.getOriginAndDestinationEditData = x;
    if (this.checkIsOrginBtn) {
      this.isCheckUpdateOrigin = true;
      this.transportationDetailForm.patchValue({ Origin: this.getOriginAndDestinationEditData });
    } else {
      this.isCheckUpdateDestination = true;
      this.transportationDetailForm.patchValue({
        destination: this.getOriginAndDestinationEditData,
      });
    }
  }

  ngOnInit(): void {
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute, 'packaging');

    this.showCustomReuse = getRolesAndPermission(
      rolesModuleName.customReuse,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomConversionAccess = getRolesAndPermission(
      rolesModuleName.customConversion,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTruckAccess = getRolesAndPermission(
      rolesModuleName.customTrucks,
      mainModuleName.customModule
    )?.isOverview;
    this.showCustomTransportAccess = getRolesAndPermission(
      rolesModuleName.customTransportScenario,
      mainModuleName.customModule
    )?.isOverview;
    this.projectFacde.getTransportScenarioManudalLocationList$
      .pipe(take(1))
      .subscribe((data: any) => {
        this.checkIsOrginBtn = false;
      });
    this.search$ = debounce(this.searchSubject.asObservable(), this.debounceTimeMs);
    this.search$.subscribe(searchValue => {
      this.searchCities(searchValue);
    });
    this.subscriptionCheckDeleteRowData =
      this.projectPackEOLDataGridService.checkDeleteRowPreRetailData$.subscribe((check: any) => {
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue('');
        this.isCheckUpdateDestination = false;
        this.isCheckUpdateOrigin = false;
        this.isCheckEditManudalDist = false;
        check[2] && check[0].length > 0 && this.deleteSetDistanceRecord(check[0], check[1]);
      });

    this.subscriptionProjectPreRetailManudalDistanceData =
      this.projectPackEOLDataGridService.editProjectPreRetailManualDistanceSubData$.subscribe(
        (editData: any) => {
          this.projectPreRetaileditManualDistanceData = editData;
          this.isCustomTruck = editData.isCustomTruck;
          this.isCheckEditManudalDist = true;
          this.transportModeId = editData.transportModeId;
          this.transportationDetailForm.controls['distance'].setValue(editData.distance);
          const location = editData.isCustomTruck ? this.customTruckItems : this.transportModeItems;
          const locationId = editData.isCustomTruck
            ? editData.customTruckId
            : editData.transportModeId;
          location.map((x: any) => {
            if (x.id == locationId) {
              this.setDestinationLocationData = x;
              this.transportationDetailForm.patchValue({
                transportModeForDistance: this.setDestinationLocationData,
              });
            }
          });
        }
      );

    this.subscriptionSaveProjectManualDistanceEOLData =
      this.projectPackEOLDataGridService.saveProjectManualDistanceEOLData$.subscribe(
        (editData: any) => {
          this.projectFacde.getTransportScenarioManudalLocationList$
            .pipe(take(1))
            .subscribe(async (data: any) => {
              data?.length == 1 && editData[1] == 'manualLocation'
                ? this.setOrigin()
                : editData[1] == 'manualLocation'
                ? this.setDestination()
                : this.addTransportDistance();
            });
        }
      );

    this.clearInputFieldProjectRetailManualDistanceEOL =
      this.projectPackEOLDataGridService.clearInputFieldProjectManualDistanceEOLData$.subscribe(
        (check: any) => {
          this.transportationDetailForm.controls['Origin'].setValue(null);
          this.transportationDetailForm.controls['destination'].setValue(null);
          this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
          this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
          this.transportationDetailForm.controls['distance'].setValue('');
          this.isCheckUpdateDestination = false;
          this.isCheckUpdateOrigin = false;
          this.isCheckEditManudalDist = false;
          this.checkIsOrginBtn = false;
        }
      );

    this.subscriptionProjectPreRetailData =
      this.projectPackEOLDataGridService.editProjectPreRetailSubData$.subscribe(
        async (editData: any) => {
          this.projectPreRetaileditData = editData[0];
          this.isCustomTruck = editData[0].isCustomTruck;
          this.transportModeId = editData[0].transportModeId;
          const distanceManualLocationvalue =
            typeof editData[0].distance === 'string'
              ? editData[0]?.distance?.substring(0, editData[0]?.distance?.indexOf(' '))
              : 0;
          this.transportationDetailForm.controls['distanceManulaLocation'].setValue(
            distanceManualLocationvalue
          );
          if (editData[1]) {
            this.projectFacde.getTransportScenarioManudalLocationList$
              .pipe(take(1))
              .subscribe(async (data: any) => {
                this.checkIsOrginBtn = data.length <= 1 ? true : false;
              });
            editData[0] = { ...editData[0] };
            editData[0].name = editData[0].originName;
            await this.fingOriginAndDestination(editData[0]);
            this.getLastItem();
            const location = editData[0].isCustomTruck
              ? this.customTruckItems
              : this.transportModeItems;
            const locationId = editData[0].isCustomTruck
              ? editData[0].customTruckId
              : editData[0].transportModeId;
            location.map((x: any) => {
              if (x.id == locationId) {
                this.setDestinationLocationData = x;
                this.transportationDetailForm.patchValue({
                  transportModeForLocation: this.setDestinationLocationData,
                });
              }
            });
          }
        }
      );

    this.reuseComponentsItemSubscription =
      this.projectPackEOLDataGridService.reuseComponentsItemSub$.subscribe((data: any) => {
        this.patchFormData(data);
      });
    this.editReuseProcessItemSubscription =
      this.projectPackEOLDataGridService.editReuseProcessItemSub$.subscribe((data: any) => {
        this.patchReuseFormData(data);
      });
    this.saveReuseProcessItemSubscription =
      this.projectPackEOLDataGridService.saveReuseProcessItemSub$.subscribe((data: any) => {
        this.addRuseData();
      });
    this.reuseDeleteComponentsItemSubscription =
      this.projectPackEOLDataGridService.reuseDeleteComponentsItemSub$.subscribe((data: any) => {
        this.resetData();
      });
    this.reuseProcessDetailForm.controls['amount'].valueChanges.subscribe((change: any) => {
      this.showReuseErr = false;
      this.showTripErr = false;
    });
  }

  resetData() {
    this.eolPreRetrailForm.get('reuseProcessDetailForm')?.get('amount')?.setValue('');
    this.reuseProcessDetailForm.patchValue({ componentName: null });
    this.transportationDetailForm.patchValue({ customScenarioItem: null });
    this.projectFacde.clearEolPreReatil('resetData');
    this.projectFacde.clearFreightProcess();
    this.projectFacde.clearComponentErrStr();
    this.isComponentDetailEdit = false;
    this.editComponentItem = null;
    this.isReuseCheck = false;
    this.isTripCheck = false;
  }

  patchReuseFormData(data: any) {
    this.existReuseProcessItem = data;
    this.findReuseProcessItem(data?.energyProcessId);
    this.energyProcessDetailForm.patchValue({
      reuseAmount: data.amount,
      cost: data.costperUnit,
      costPackage: data.costperPackage,
    });
    this.isCheckReuseProcessEdit = true;
  }

  findReuseProcessItem(id: any) {
    this.energyFillinListiItems.filter((x: any) => {
      if (x.id == id) {
        this.energyProcessDetailForm.patchValue({ reuseName: x });
      }
    });
  }

  patchFormData(data: any) {
    if (data?.percentageOfReuse) {
      this.isReuseCheck = true;
      this.isTripCheck = false;
      this.eolPreRetrailForm
        .get('reuseProcessDetailForm')
        ?.get('amount')
        ?.setValue(data.percentageOfReuse);
    } else {
      this.isTripCheck = true;
      this.isReuseCheck = false;
      this.eolPreRetrailForm.get('reuseProcessDetailForm')?.get('amount')?.setValue(data.noOfTrip);
    }
    this.editComponentItem = data;
    if (data?.componentId) {
      this.findComponentItem(data?.componentId);
    }
    const reuseFillingProcessItems = data?.reuseFillingProcessItems.map((x: any) => {
      return {
        ...x,
        processName: x.reuseFillingProcessName ?? x.processName,
      };
    });
    this.transportaionId = data.transportaionId || 2;
    this.isComponentDetailEdit = true;
    this.stepFun();
    if (this.transportaionId == 4) {
      this.CustomtransportScenarioId = data.customTransportScenarioId;
      this.getCustomFreight();
      this.customeLocationTransportationItems = data?.customeLocationTransportationItems.map(
        (x: any) => {
          return {
            ...x,
            cityName: x.originName,
          };
        }
      );
    }
    this.projectFacde.preRetailReuseSetData(
      reuseFillingProcessItems,
      data.transportaionId,
      data.transportaionId == 2
        ? data.locationTransportationItems
        : data.transportaionId == 3
        ? data.distanceTransportationItems
        : this.customeLocationTransportationItems
    );
    setTimeout(() => {
      document.getElementById('retailModal')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  getCustomFreight() {
    this.customtransportScenarioItems.find((x: any) => {
      if (this.CustomtransportScenarioId == x.id) {
        this.transportationDetailForm.patchValue({ customScenarioItem: x });
      }
    });
  }

  findComponentItem(id: number) {
    const selectedItem = this.componenetListItems.find((x: any) => x.idStr == id);
    if (selectedItem) {
      this.reuseProcessDetailForm.patchValue({ componentName: [selectedItem] });
    }
  }

  getValueOfcheckbox(event: any, type: any) {
    this.isReuseCheck = false;
    this.isTripCheck = false;
    event.target.checked && type == 'reuse'
      ? (this.isReuseCheck = true)
      : event.target.checked && type == 'trip'
      ? (this.isTripCheck = true)
      : (this.isReuseCheck = false);
    this.reuseProcessDetailForm.controls['amount'].reset();
    this.showTripErr = false;
    this.showReuseErr = false;
    this.projectFacde.clearComponentErrStr();
  }

  initializeData() {
    this.transportModeItems = this.getEolPreRetailData.transportModeItems;
    this.customTruckItems = this.getEolPreRetailData.customTruckItems;
    this.updateCompOptions();
    this.reuseTypeList = this.getEolPreRetailData.reuseTypeItems;
    this.isCostTrunOff = !this.getEolPreRetailData.isCostTrunOff;
    this.customReuseItems = this.getEolPreRetailData.customReuseItems;
    this.pathName = this.getEolPreRetailData.pathName;
    this.eolPreRetrailForm = this.formBuilder.group({
      reuseProcessDetailForm: this.formBuilder.group({
        reuseType: [null, Validators.required],
        componentName: [null, Validators.required],
        amount: ['', [nonNegativeValidator, Validators.min(0)]],
      }),
      energyProcessDetailForm: this.formBuilder.group({
        reuseName: [null, Validators.required],
        reuseAmount: ['', [Validators.required, nonNegativeValidator, Validators.maxLength(100)]],
        cost: ['', Validators.maxLength(100)],
        costPackage: [{ value: null, disabled: true }],
      }),
      transportationDetailForm: this.formBuilder.group({
        Origin: [null],
        destination: [null],
        transportModeForLocation: [null],
        transportModeForDistance: [null],
        distanceManulaLocation: [''],
        distance: [''],
        customScenarioItem: [null],
      }),
    });
    this.reuseProcessDetailForm = this.eolPreRetrailForm.controls['reuseProcessDetailForm'];
    this.transportationDetailForm = this.eolPreRetrailForm.controls['transportationDetailForm'];
    this.energyProcessDetailForm = this.eolPreRetrailForm.controls['energyProcessDetailForm'];
    this.setFormData();
    setDelayedFlag(this.gridLoaded, true, 200);
  }

  noSpecialKeys(event: any) {
    const allowedKeys = /^[0-9.]$/; // RegEx to allow digits and one decimal point

    if (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowRight' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft'
    )
      return;

    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }

    // logic to allow only one decimal point
    const input = event.target.value;
    const hasDecimalPoint = input.includes('.');

    if (event.key === '.' && hasDecimalPoint) {
      event.preventDefault();
    }
  }

  commonInputSearch(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForCountry(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  getCustomTransport() {
    this.customService.getAllCustomTransportList().subscribe((res: any) => {
      this.customtransportScenarioItems = res.data;
    });
  }

  setFormData() {
    this.transportaionId = this.getEolPreRetailData.transportaionId || 2;
    this.customtransportScenarioItems = this.getEolPreRetailData.customtransportScenarioItems;
    this.eolPreRetrailForm
      .get('reuseProcessDetailForm')
      ?.get('reuseType')
      ?.setValue(this.isConsumer ? this.reuseTypeList[1] : this.reuseTypeList[0]);
    this.energyFillinListiItems = this.getEolPreRetailData.energyFillinListiItems;
    this.reuseColumnDef[0].cellEditorParams['reuseProcessList'] = this.energyFillinListiItems;
    this.reuseColumnDef[0].cellEditorParams['customReuseProcessList'] = this.customReuseItems;
    this.stepFun();
  }

  stepFun() {
    this.selectedBox = this.TransportationEnum.find((x: any, index: any) => {
      return this.transportaionId == this.TransportationEnum[index].id;
    });

    switch (this.selectedBox?.id) {
      case 2:
        this.wholeData[0]['img'] = this.loactionWhite;
        this.wholeData[1]['img'] = this.distanceBlack;
        this.wholeData[2]['img'] = this.customBlack;
        this.selectLocation = true;
        this.selectDistance = false;
        this.selectCustom = false;
        break;
      case 3:
        this.wholeData[1]['img'] = this.distanceWhite;
        this.wholeData[0]['img'] = this.locationBlack;
        this.wholeData[2]['img'] = this.customBlack;
        this.selectDistance = true;
        this.selectLocation = false;
        this.selectCustom = false;
        break;
      case 4:
        this.wholeData[1]['img'] = this.distanceBlack;
        this.wholeData[0]['img'] = this.locationBlack;
        this.wholeData[2]['img'] = this.customWhite;
        this.selectCustom = true;
        this.selectDistance = false;
        this.selectLocation = false;
        break;
      default:
        break;
    }
  }

  manualLocation(data: any) {
    this.selectLocation = false;
    this.selectDistance = false;
    this.selectCustom = false;
    this.isCheckEditManudalDist = false;
    this.isCheckUpdateOrigin = false;
    this.isCheckUpdateDestination = false;
    this.isCustomTruck = false;
    this.locationProcessDef =
      this.projectPackEOLDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectPackEOLDataGridService.getTransportModalForManualDestinationDataColumn();
    this.locationProcessDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.wholeData[0]['img'] = this.locationBlack;
    this.wholeData[1]['img'] = this.distanceBlack;
    this.wholeData[2]['img'] = this.customBlack;
    switch (data.type) {
      case 'location':
        this.wholeData[0]['img'] = this.loactionWhite;
        this.selectedBox.id = 2;
        this.selectLocation = true;
        this.isShowCustomTransportList = false;
        this.transportaionId = 2;
        this.percenteageMassLoad = 0;
        this.projectFacde.getTransportScenarioManudalLocationList$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.manudaLocationPreRetail(updatedData, 'reset');
            }
          });
        break;
      case 'distance':
        this.wholeData[1]['img'] = this.distanceWhite;
        this.selectedBox.id = 3;
        this.selectDistance = true;
        this.isShowDistantField = false;
        this.isShowCustomTransportList = false;
        this.transportaionId = 3;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue(null);
        this.percenteageMassLoad = 0;
        this.projectFacde.getTransportScenarioManualDistanceList$
          .pipe(take(1))
          .subscribe((data: any) => {
            if (data && data.length > 0) {
              const updatedData = data.map((item: any) => ({
                ...item,
                enableEditing: false,
              }));
              this.projectFacde.manudaDistancePreRetail(updatedData, 'reset');
            }
          });
        break;
      case 'custom':
        this.wholeData[2]['img'] = this.customWhite;
        this.selectedBox.id = 4;
        this.selectCustom = true;
        this.isShowDistantField = false;
        this.transportaionId = 4;
        this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
        this.transportationDetailForm.controls['distance'].setValue(null);
        this.transportationDetailForm.controls['transportModeForDistance'].clearValidators();
        this.transportationDetailForm.controls['distance'].clearValidators();
        this.transportationDetailForm.controls['Origin'].setValue(null);
        this.transportationDetailForm.controls['destination'].setValue(null);
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.transportationDetailForm.controls['distanceManulaLocation'].setValue(null);
        this.projectFacde.clearTransportScenario();
        this.projectFacde.clearFreightProcess();
        this.percenteageMassLoad = 0;
        this.addCustomFreight();
        break;
      default:
        break;
    }
  }

  chnageCustomTruck(event: any) {
    this.isCustomTruck = event.target.checked ? true : false;
    this.locationProcessDef =
      this.projectPackEOLDataGridService.getTransportModalForManualLocationDataColumn();
    this.distanceProcessColumnDef =
      this.projectPackEOLDataGridService.getTransportModalForManualDestinationDataColumn();
    this.locationProcessDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.distanceProcessColumnDef.forEach((column: any) => {
      if (this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = false;
      } else if (!this.isCustomTruck && column.field == 'persanteageMassLoad') {
        column.hide = true;
      }
    });
    this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
    this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
  }

  chnageCustomReuse(event: any) {
    this.isCustomReuse = event.target.checked ? true : false;
    this.energyProcessDetailForm.controls['reuseName'].setValue(null);
  }
  selectEvent(event: any) {
    this.originId = event.idStr;
    this.keywordAuto = '';
    this.selectedCities = [];
  }
  onScroll() {
    if (this.selectedCities?.length < 50) return;
    this.pageNumber++;
    this.isLoading = true;
    this.searchCities(this.searchValue);
  }
  onKeyDownEvent(event: any) {
    if (
      this.keywordAuto == undefined ||
      this.keywordAuto == null ||
      typeof this.keywordAuto == 'object'
    ) {
      this.keywordAuto = '';
    }
    onKeyDown(event, this.keywordAuto);
  }
  onSearch(searchValue: string) {
    if (this.keywordAuto == undefined || this.keywordAuto == null) {
      this.keywordAuto = '';
    }
    this.keywordAuto = this.keywordAuto?.trimStart();
    if (this.keywordAuto.length) {
      this.isLoading = true;
      this.pageNumber = 1;
      this.searchValue = this.keywordAuto;
      this.selectedCities = [];
      this.searchSubject.next(this.keywordAuto);
    }
  }

  onClearSearch(event: any) {
    this.isLoading = false;
    this.selectedCities = [];
    this.pageNumber = 1;
    this.searchValue = '';
    this.autoForOrigin?.close();
    this.autoForDestination?.close();
  }

  async searchCities(searchValue: string) {
    const res: any = await this.sharedService.getAllFilterCity(
      this.pageNumber,
      searchValue,
      this.isShowPort
    );
    this.selectedCities = this.pageNumber === 1 ? res.data : [...this.selectedCities, ...res.data];
    this.autoForOrigin?.focus();
    this.autoForDestination?.focus();
    this.isLoading = false;
  }

  showPorts(event: any) {
    this.transportationDetailForm.controls['Origin'].setValue(null);
    this.transportationDetailForm.controls['destination'].setValue(null);
    this.isShowPort = event.target.checked;
  }

  getCustomTruckList() {
    this.projectService.getCustomTruckList().subscribe((data: any) => {
      this.customTruckItems = data.data;
    });
  }

  getCustomReuseList() {
    this.projectService.getCustomReuseList().subscribe((data: any) => {
      this.customReuseItems = data.data;
      this.reuseColumnDef[0].cellEditorParams['customReuseProcessList'] = this.customReuseItems;
    });
  }

  inlineDataEditEvent(record: any) {
    this.projectFacde.manudaLocationPreRetail(record[1], 'edit');
  }

  setOrigin() {
    this.setOriginsubmitted = true;
    if (
      this.transportationDetailForm.controls['Origin']?.value?.hasOwnProperty('name') &&
      this.transportationDetailForm.controls['Origin'].value != null
    ) {
      this.transportScenarioData = {
        id: 0,
        originName: this.transportationDetailForm.value.Origin.name,
        distance: '',
        originId: this.originId,
        cityId: this.originId,
      };
      this.projectFacde.manudaLocationPreRetail(
        this.transportScenarioData,
        this.isCheckUpdateOrigin ? 'edit' : 'add'
      );
      this.setOriginsubmitted = false;
      this.checkIsOrginBtn = false;
      this.isCheckUpdateOrigin = false;
      this.transportationDetailForm.controls['Origin'].setValue(null);
    } else {
      return;
    }
  }

  async getCalculateDisForNextRecord(lastItem: any, nextItem: any) {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [lastItem],
      destinations: [nextItem.originName],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.setManualLocationDisForNextRecord = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  changeNextRecordDistance() {
    this.projectFacde.getTransportScenarioManudalLocationList$
      .pipe(take(1))
      .subscribe(async (data: any) => {
        const startIndex = data.findIndex(
          (item: any) => item.index === this.projectPreRetaileditData.index
        ); // Index to start checking after
        if (this.isCheckUpdateDestination && startIndex < data.length - 1) {
          let destinationNextRecord =
            data[
              data.findIndex((item: any) => item.index === this.projectPreRetaileditData.index) + 1
            ];
          const lastItemNextRecord = this.transportationDetailForm.value.destination;
          try {
            await this.getCalculateDisForNextRecord(lastItemNextRecord.name, destinationNextRecord);
            Object.freeze(destinationNextRecord);
            const objCopy = { ...destinationNextRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            destinationNextRecord = objCopy;
            this.projectFacde.manudaLocationPreRetail(destinationNextRecord, 'edit');
          } catch (error) {
            // Handle error, e.g., log it or show a user-friendly message.
            console.error('Error:', error);
          }
        }
      });
  }

  deleteSetDistanceRecord(allRecorsds: any, deleteRecord: any) {
    this.projectFacde.getTransportScenarioManudalLocationList$
      .pipe(take(1))
      .subscribe(async (allManualLocationData: any) => {
        const indexToDelete = allRecorsds.findIndex(
          (record: any) => record.index === deleteRecord.index
        );
        if (indexToDelete !== -1) {
          // Delete the record
          // Create a new array excluding the deleted record
          const newArray = allRecorsds.filter((record: any, index: any) => index !== indexToDelete);
          const aboveRecord = newArray[indexToDelete - 1];
          let belowRecord = newArray[indexToDelete];
          // newArray now contains the array with the specified record deleted
          if (!!belowRecord) {
            await this.getCalculateDisForNextRecord(aboveRecord.originName, belowRecord);
            Object.freeze(belowRecord);
            const objCopy = { ...belowRecord };
            objCopy.distance = this.setManualLocationDisForNextRecord;
            objCopy.index = allManualLocationData[indexToDelete].index;
            belowRecord = objCopy;
            this.projectFacde.manudaLocationPreRetail(belowRecord, 'edit');
          }
        }
      });
  }

  seaDistanceMatrix(lastItem: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const fromCity = lastItem.originName;
      const toCity = this.transportationDetailForm.controls['destination'].value?.name;
      const bothCity: string[] = [fromCity, toCity];
      const geocoder = new google.maps.Geocoder();

      // Use map to create an array of observables for geocoding requests
      const geocodeRequests = bothCity.map((address: string) => {
        return new Observable(observer => {
          geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
              const location = results![0].geometry.location;
              observer.next({ latitude: location.lat(), longitude: location.lng() });
              observer.complete();
            } else {
              observer.error(`Geocode was not successful for ${address} due to: ` + status);
            }
          });
        });
      });

      // Wait for all geocoding requests to complete
      forkJoin(geocodeRequests).subscribe(
        async (results: any[]) => {
          const [fromLocation, toLocation] = results;
          const latFrom = fromLocation.latitude;
          const lngFrom = fromLocation.longitude;
          const latTo = toLocation.latitude;
          const lngTo = toLocation.longitude;

          // Now you can make the API call
          const distanceType = this.sharedService.getDistanceTypeByTransportMode(
            this.transportModeId
          );
          const res = await this.sharedService.getDistanceAndTime(
            latFrom,
            lngFrom,
            latTo,
            lngTo,
            lastItem.originId,
            this.transportationDetailForm.controls['destination'].value?.idStr,
            distanceType
          );
          if (
            this.transportModeId == commonEnum.AIR_INTERNATIONAL ||
            this.transportModeId == commonEnum.AIR_DOMESTIC
          ) {
            this.transportationDetailForm.controls['distance'].setValue(
              formatNumber(res.data) + ' ' + 'km'
            );
            this.setManualLocationDis = formatNumber(res.data) + ' ' + 'km';
          } else if (this.transportModeId == commonEnum.SHIP_INTERNATIONAL) {
            this.seaDistance = formatNumber(res.data) + ' ' + 'km';
          }
          resolve(); // Resolve the promise once everything is done
        },
        error => {
          console.error(error);
          reject(error); // Reject the promise in case of an error
        }
      );
    });
  }

  async setDestination() {
    this.setDestinationsubmitted = true;
    if (
      this.transportationDetailForm.controls['destination']?.value?.hasOwnProperty('name') &&
      !!this.transportationDetailForm.controls['transportModeForLocation'].value &&
      !!this.transportationDetailForm.controls['destination'].value
    ) {
      if (
        this.isCheckUpdateDestination &&
        this.transportationDetailForm.controls['distanceManulaLocation'].value == 0
      ) {
        return;
      }
      if (
        this.transportModeName?.toLowerCase() == commonEnum.shipName ||
        this.transportModeName?.toLowerCase() == commonEnum.airName ||
        this.transportModeName?.toLowerCase() == commonEnum.airDomesticName
      ) {
        await this.seaDistanceMatrix(this.lastItem);
      } else {
        await this.calculateDistance(this.lastItem);
      }
      if (this.messageType != 1) {
        if (
          (this.transportationDetailForm.value.destination?.idStr ||
            this.transportationDetailForm.value.destination?.originId) ==
            this.projectPreRetaileditData?.originId &&
          this.transportModeId == this.projectPreRetaileditData?.transportModeId
        ) {
          this.setApiResDistance = true;
        }
        !!this.projectPreRetaileditData?.originId &&
          (this.transportationDetailForm.value.destination?.idStr ||
            this.transportationDetailForm.value.destination?.originId) !=
            this.projectPreRetaileditData?.originId &&
          this.changeNextRecordDistance();
        this.destinationData = {};
        this.destinationData['id'] = 0;
        if (this.isCheckUpdateDestination) {
          this.destinationData['index'] = this.projectPreRetaileditData.index;
        }
        this.destinationData['isCustomTruck'] = this.isCustomTruck;
        this.isCustomTruck
          ? (this.destinationData['customTruckId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectPreRetaileditData.transportModeId)
          : (this.destinationData['transportModeId'] = !!this.transportModeId
              ? this.transportModeId
              : this.projectPreRetaileditData.transportModeId);
        this.destinationData['transportModeName'] =
          this.transportationDetailForm.value.transportModeForLocation.name;
        this.destinationData['persanteageMassLoad'] = this.percenteageMassLoad || 0;
        const newManualLocationDisatance =
          this.transportationDetailForm.controls['distanceManulaLocation'].value;
        const getDisType =
          typeof this.projectPreRetaileditData?.distance == 'string' &&
          !!this.projectPreRetaileditData?.distance
            ? this.projectPreRetaileditData?.distance?.substring(
                this.projectPreRetaileditData.distance.indexOf(' ') + 1
              )
            : 'km';
        const newVal = newManualLocationDisatance + ' ' + (getDisType == '0' ? ' ' : getDisType);

        if (
          this.transportationDetailForm.controls['destination']?.value?.name?.includes('Port') &&
          (this.lastItem?.originName?.includes('Port') || this.lastItem?.name?.includes('Port')) &&
          this.transportModeName.toLowerCase() == commonEnum.shipName
        ) {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance ? newVal : this.seaDistance;
        } else {
          this.destinationData['distance'] =
            this.isCheckUpdateDestination && this.setApiResDistance
              ? newVal
              : this.setManualLocationDis;
        }

        this.destinationData['originId'] =
          this.transportationDetailForm.value.destination.idStr ||
          this.transportationDetailForm.value.destination.originId;
        this.destinationData['idStr'] = this.destinationData['originId'];
        this.destinationData['cityId'] =
          this.transportationDetailForm.value.destination.idStr ||
          this.transportationDetailForm.value.destination.originId;
        this.destinationData['originName'] = this.transportationDetailForm.value.destination.name;
        (this.destinationData['description'] = this.isCustomTruck
          ? 'Truck.png'
          : this.transportationDetailForm.controls['transportModeForLocation'].value?.description),
          (this.destinationData['isOrigin'] = this.isCheckUpdateDestination
            ? this.projectPreRetaileditData.isOrigin
            : true);
        this.transportationDetailForm.controls['destination'].reset();
        this.transportationDetailForm.controls['transportModeForLocation'].setValue(null);
        this.projectFacde.manudaLocationPreRetail(
          this.destinationData,
          this.isCheckUpdateDestination ? 'edit' : 'add'
        );
        this.setOriginsubmitted = false;
        this.setDestinationsubmitted = false;
        this.isCheckUpdateDestination = false;
        this.setApiResDistance = false;
        this.messageType = 0;
        this.isValidPort = '';
      } else if (this.messageType == 1) {
        this.transportationDetailForm.controls['transportModeForLocation'].reset();
        this.setDestinationsubmitted = false;
        this.messageType = 0;
      } else {
        this.setDestinationsubmitted = true;
      }
    }
  }

  getCostPerPackage() {
    const amount = this.energyProcessDetailForm.controls['reuseAmount']?.value || 0;
    const costPerUnit = this.energyProcessDetailForm.controls['cost']?.value || 0;
    const result = (amount * costPerUnit) / 1000;
    this.energyProcessDetailForm.controls['costPackage'].setValue(result);
  }

  addRuseData() {
    this.isReusesubmitted = true;
    if (
      ((!!this.energyProcessDetailForm.controls['reuseName'].value &&
        !!this.energyProcessDetailForm.controls['reuseAmount'].value) ||
        (this.isCustomReuse && !!this.energyProcessDetailForm.controls['reuseName'].value)) &&
      !this.energyProcessDetailForm.controls['reuseAmount'].hasError('nonNegative')
    ) {
      this.reusePayload = {};
      this.isCustomReuse
        ? (this.reusePayload['customReuseId'] =
            this.energyProcessDetailForm.controls['reuseName'].value?.idStr)
        : (this.reusePayload['energyProcessId'] =
            this.energyProcessDetailForm.controls['reuseName'].value?.id);
      this.reusePayload['isCustomReuse'] = this.isCustomReuse;
      this.reusePayload['processName'] =
        this.energyProcessDetailForm.value.reuseName.name ||
        this.energyProcessDetailForm.value.reuseName.description;
      this.reusePayload['amount'] = this.energyProcessDetailForm.controls['reuseAmount']?.value;
      this.reusePayload['costperUnit'] = this.energyProcessDetailForm.controls['cost']?.value;
      this.reusePayload['costperPackage'] =
        this.energyProcessDetailForm.controls['costPackage']?.value;
      if (this.isCheckReuseProcessEdit) {
        this.reusePayload['index'] = this.existReuseProcessItem.index;
      }
      this.projectFacde.preRetailReuseAction(this.reusePayload, 'add');
      this.energyProcessDetailForm.reset();
      this.isReusesubmitted = false;
      this.isCheckReuseProcessEdit = false;
    }
  }

  getLastItem() {
    this.projectFacde.getTransportScenarioManudalLocationList$
      .pipe(take(1))
      .subscribe((data: any) => {
        this.lastItem = this.isCheckUpdateDestination
          ? data[
              data.findIndex((item: any) => item.index === this.projectPreRetaileditData.index) - 1
            ]
          : data[data?.length - 1];
      });
  }

  changeTransportMode(event: any) {
    if (event?.id) {
      this.transportModeId = event.id;
      this.transportModeName = event.name;
      this.transportModeDescription = event.description;
      this.getLastItem();
    }
    if (event?.id && this.isCustomTruck) {
      this.getMassLoad(event);
    }
  }

  getMassLoad(event: any, from?: any) {
    if (event.id) {
      this.projectService.getTruckMassLoad(event.id || event.truckId).subscribe((res: any) => {
        this.percenteageMassLoad = res.data.percenteageMassLoad;
      });
    }
  }

  async calculateDistance(lastItem: any) {
    const payload = {
      origin: lastItem?.originName,
      destination: this.transportationDetailForm.controls['destination'].value?.name,
      destinationId: Number(this.transportationDetailForm.controls['destination'].value?.idStr),
      iscustomtruck: this.isCustomTruck,
      transportmodeId: this.transportModeId,
      customTransoportScenarioDetails: [
        {
          id: 0,
          cityId: lastItem.originId,
          cityName: lastItem.originName,
          transportModeName: this.transportModeName,
          customTransportScenarioId: 0,
          imageName: lastItem.description,
        },
      ],
    };
    const response = await this.customService.getSeaDistanceForTransportAsync(payload);
    this.transportationDetailForm.controls['distance'].setValue(response.data?.distance);
    if (
      (response.data.distance >= 0 && response.data.isShip) ||
      response?.message.includes('must be a valid Port')
    ) {
      this.transportationDetailForm.controls['distance'].setValue(response?.data.distance);
      const setManualLocationDis = response?.data.distance;
      this.setManualLocationDis = setManualLocationDis;
      this.isValidPort = response.message;
      this.messageType = response.messageType;
      // this.customFacade.setCustomTransportError('');
      return response;
    } else {
      await this.getCalculateDis();
    }
  }

  async getCalculateDis() {
    await this.mapsAPILoader.load();
    const service = new google.maps.DistanceMatrixService();
    const request: any = {
      origins: [this.lastItem.originName],
      destinations: [this.transportationDetailForm.controls['destination'].value.name],
      travelMode: 'DRIVING',
    };
    return new Promise((resolve, reject) => {
      service.getDistanceMatrix(request, (response: any, status: any) => {
        if (status === 'OK') {
          const distance = !!response.rows[0].elements[0].distance?.text
            ? response.rows[0].elements[0].distance?.text
            : '0 km';
          this.transportationDetailForm.controls['distance'].setValue(distance);
          this.setManualLocationDis = distance;
          resolve(distance);
        } else {
          reject(new Error(`Distance calculation failed with status: ${status}`));
        }
      });
    });
  }

  addTransportDistance() {
    this.setManualDistanceSubmitted = true;
    if (
      this.transportationDetailForm.controls['transportModeForDistance'].value &&
      this.transportationDetailForm.controls['distance'].value
    ) {
      this.transportScenarioDataForDistance = {};
      this.transportScenarioDataForDistance['id'] = 0;
      if (this.isCheckEditManudalDist) {
        this.transportScenarioDataForDistance['index'] =
          this.projectPreRetaileditManualDistanceData.index;
      }
      this.transportScenarioDataForDistance['isCustomTruck'] = this.isCustomTruck;
      this.isCustomTruck
        ? (this.transportScenarioDataForDistance['customTruckId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectPreRetaileditManualDistanceData.transportModeId)
        : (this.transportScenarioDataForDistance['transportModeId'] = !!this.transportModeId
            ? this.transportModeId
            : this.projectPreRetaileditManualDistanceData.transportModeId);
      this.transportScenarioDataForDistance['transportModeName'] =
        this.transportationDetailForm.value.transportModeForDistance.name;
      this.transportScenarioDataForDistance['distance'] =
        this.transportationDetailForm.value.distance;
      (this.transportScenarioDataForDistance['description'] = this.isCustomTruck
        ? 'Truck.png'
        : this.transportationDetailForm.controls['transportModeForDistance'].value?.description),
        (this.transportScenarioDataForDistance['persanteageMassLoad'] =
          this.percenteageMassLoad || 0);
      this.projectFacde.manudaDistancePreRetail(
        this.transportScenarioDataForDistance,
        this.isCheckEditManudalDist ? 'edit' : 'add'
      );
      this.setManualDistanceSubmitted = false;
      this.isCheckEditManudalDist = false;
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
      this.transportationDetailForm.controls['distance'].setValue(null);
    }
  }

  changeCustomTransportItem(event: any) {
    this.projectFacde.clearFreightProcess();
    if (!!event.id) {
      this.customFreightSelectData = event;
    }
  }

  resetTransport() {
    this.customFreightSelectData = null;
  }
  addCustomFreight() {
    if (!!this.customFreightSelectData) {
      this.CustomtransportScenarioId = this.customFreightSelectData.id;
      this.projectFacde.customFreightActions(
        this.CustomtransportScenarioId,
        this.customFreightSelectData.isCustomSiteTransport
      );
    }
  }

  mapData(arr: any[]): any[] {
    return arr.map(ele => ({
      ...ele,
      imageName: ele.description || ele.transportModeImage || ele.imageName,
      cityName: ele.originName || ele.cityName,
    }));
  }

  checkValidation() {
    if (
      this.isTripCheck &&
      (this.reuseProcessDetailForm.controls['amount']?.value > 9999 ||
        this.reuseProcessDetailForm.controls['amount']?.value < 1)
    ) {
      this.showTripErr = true;
    } else if (
      this.isReuseCheck &&
      (this.reuseProcessDetailForm.controls['amount']?.value > 99.999 ||
        this.reuseProcessDetailForm.controls['amount']?.value < 0.1)
    ) {
      this.showReuseErr = true;
    }
  }

  onAmountBlur(eve: any) {
    this.checkValidation();
  }

  addComponentTransport(
    data: any,
    distanceData: any,
    customData: any,
    getPreRetailReuseActionList: any
  ) {
    this.componentSubmitted = true;
    let payloadArray: any = [];
    if (
      this.reuseProcessDetailForm.controls['componentName'].invalid ||
      this.reuseProcessDetailForm.controls['amount'].hasError('nonNegative') ||
      (this.isTripCheck &&
        (this.reuseProcessDetailForm.controls['amount']?.value > 9999 ||
          this.reuseProcessDetailForm.controls['amount']?.value < 1)) ||
      (this.isReuseCheck &&
        (this.reuseProcessDetailForm.controls['amount']?.value > 99.999 ||
          this.reuseProcessDetailForm.controls['amount']?.value < 0.1))
    ) {
      this.checkValidation();
      return;
    } else {
      if (this.selectLocation) {
        data = data;
        distanceData = [];
        this.CustomtransportScenarioId = undefined;
      } else if (this.selectDistance) {
        distanceData = distanceData;
        data = [];
        this.CustomtransportScenarioId = undefined;
      } else {
        data = [];
        distanceData = [];
      }
      let dataList;
      data = data.map((item: any) => {
        if (typeof item.distance === 'string' && item.distance != 0) {
          const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
          Object.freeze(item);
          const objCopy = { ...item };
          const distanceWithoutCommas = item.distance.replace(/,/g, '');
          objCopy.distance = parseFloat(distanceWithoutCommas);
          objCopy.unit = type;
          item = objCopy;
        }
        return item;
      });

      if (!!distanceData) {
        distanceData = distanceData.map((item: any) => {
          return {
            ...item,
            unit: 'km',
          };
        });
      }
      dataList =
        data.length > 0
          ? data
          : distanceData.length > 0
          ? distanceData
          : customData.length > 0
          ? customData
          : [];
      this.transportIcons = dataList.map((ele: any, index: any, arr: any) => {
        return arr[index]?.description || arr[index]?.transportModeImage || arr[index]?.imageName;
      });
      const reuseNameList = getPreRetailReuseActionList
        ?.map((item: any) => item?.processName)
        .join(',');
      const reuseAmountList = getPreRetailReuseActionList
        ?.map((item: any) => item?.amount)
        .join(',');
      const reusecostList = getPreRetailReuseActionList
        ?.map((item: any) => item?.costperUnit)
        .join(',');
      const reuseCostPackageList = getPreRetailReuseActionList
        ?.map((item: any) => item?.costperPackage)
        .join(',');
      this.mainAmount = this.reuseProcessDetailForm.controls['amount'].value;
      data = this.mapData(data);
      distanceData = this.mapData(distanceData);
      customData = this.mapData(customData);
      this.reuseProcessDetailForm.controls['componentName']?.value?.forEach(
        (record: any, indx: any) => {
          const payload: any = {};
          payload['componentName'] = record.description;
          payload['transportIcons'] = this.transportIcons;
          payload['componentId'] = record.idStr;
          payload['processName'] = reuseNameList;
          payload['reuseProcesAmount'] = reuseAmountList;
          payload['reuseProcesCostperUnit'] = reusecostList;
          payload['reuseProcesCostperPackage'] = reuseCostPackageList;
          payload['reuseFillingProcessItems'] = getPreRetailReuseActionList;
          payload['reuseProcesAmountList'] = getPreRetailReuseActionList;
          payload['locationTransportationItems'] = data;
          payload['distanceTransportationItems'] = distanceData;
          payload['customTransportationItems'] = customData;
          payload['checkEolPreRetail'] = true;
          payload['customTransportScenarioId'] = this.CustomtransportScenarioId;
          payload['transportaionId'] = this.transportaionId;
          payload['transportationId'] = this.transportaionId;
          this.isReuseCheck
            ? (payload['percentageOfReuse'] = this.mainAmount)
            : (payload['noOfTrip'] = this.mainAmount);
          payload['index'] = this.isComponentDetailEdit ? this.editComponentItem.index : indx + 1;
          payload['isDistance'] = true;
          payloadArray.push(payload);
        }
      );
      this.projectFacde.eolPreRetailAddComponent(
        payloadArray,
        this.isComponentDetailEdit ? 'edit' : 'add'
      );
      this.transportationDetailForm.controls['transportModeForDistance'].setValue(null);
      this.transportationDetailForm.controls['distance'].setValue(null);
      this.energyProcessDetailForm.controls['reuseName'].setValue(null);
      this.energyProcessDetailForm.controls['reuseAmount'].setValue('');
      this.componentSubmitted = false;
      this.submitted = false;
      this.isReusesubmitted = false;
      this.isComponentDetailEdit = false;
      this.isRowEditable = false;
      this.energyProcessDetailForm.controls['reuseAmount']?.markAsUntouched();
      this.reuseProcessDetailForm.controls['componentName'].setValue(null);
      this.reuseProcessDetailForm.controls['amount'].setValue('');
      this.projectFacde.clearFreightProcess();
      this.projectFacde.clearDistanceProcess();
      this.projectFacde.clearLocationProcess();
      this.projectFacde.clearPreRetailReuseActionList();
    }
  }

  getComponentListData(eve: any) {
    if (!eve?.id) return this.reuseProcessDetailForm.controls['componentName'].setValue(null);
    this.reuseProcessDetailForm.controls['componentName'].setValue(null);
    const storageTypeId = eve.id == 1 ? 2 : 3;
    this.projectService.getComponentList(storageTypeId, this.scenarioId).subscribe((res: any) => {
      const componentListItems = res.data?.map((x: any) => {
        return {
          ...x,
          disabled: x.selected,
        };
      });
      this.componenetListItems = componentListItems;
    });
  }

  onClose() {
    this.projectFacde.clearEolPreReatil();
    this.projectFacde.clearFreightProcess();
    this.projectFacde.clearComponentErrStr();
    this.modal.close();
  }

  saveData(getComponentPreRetailList: any) {
    this.submitted = true;
    this.checkHitButton = getComponentPreRetailList.length > 0 ? true : false;
    if (
      getComponentPreRetailList.length > 0 &&
      this.eolPreRetrailForm.get('reuseProcessDetailForm')?.get('reuseType')?.valid
    ) {
      this.submitted = false;
      const mainPayload: any = {};
      getComponentPreRetailList = cloneDeep(getComponentPreRetailList);
      getComponentPreRetailList.forEach((data: any) => {
        data.locationTransportationItems = data.locationTransportationItems.map((item: any) => {
          if (typeof item.distance === 'string' && item.distance != 0) {
            const type = item.distance?.substring(item.distance.indexOf(' ') + 1);
            Object.freeze(item);
            const objCopy = { ...item };
            const distanceWithoutCommas = item.distance.replace(/,/g, '');
            objCopy.distance = parseFloat(distanceWithoutCommas);
            objCopy.unit = type;
            item = objCopy;
          }
          return item;
        });

        if (!!data.distanceTransportationItems) {
          data.distanceTransportationItems = data.distanceTransportationItems.map((item: any) => {
            return {
              ...item,
              unit: 'km',
            };
          });
        }
      });

      getComponentPreRetailList.forEach((data: any) => {
        const addReuseFillingDatalistIteams: any = {
          transportaionId: data.transportaionId,
          componentId: data.componentId,
          customTransportScenarioId: data.customTransportScenarioId,
          reuseFillingProcessItems: data.reuseFillingProcessItems,
          locationTransportationItems: data.locationTransportationItems,
          distanceTransportationItems: data.distanceTransportationItems,
          percentageOfReuse: data.percentageOfReuse,
          noOfTrip: data.noOfTrip,
        };
        this.tempData.push(addReuseFillingDatalistIteams);
      });
      this.isReuseCheck
        ? (this.tempData['percentageOfReuse'] = this.mainAmount)
        : (this.tempData['noOfTrip'] = this.mainAmount);
      mainPayload['id'] = this.getEolPreRetailData.id || 0;
      mainPayload['scenarioId'] = this.getEolPreRetailData.scenarioId;
      mainPayload['isConsumer'] =
        this.eolPreRetrailForm
          .get('reuseProcessDetailForm')
          ?.get('reuseType')
          ?.value?.name?.toLowerCase() == 'consumer reuse'
          ? true
          : false;
      mainPayload['addReuseFillingDatalistIteams'] = this.tempData;
      this.saveNewPreRetailEvent.emit({ mainPayload: mainPayload, pathName: this.pathName });
      this.projectFacde.clearEolPreReatil();
      this.projectFacde.clearFreightProcess();
      this.projectFacde.clearComponentErrStr();
    }
  }

  updateCompOptions() {
    const componentListItems = this.getEolPreRetailData.componenetListItems.map((x: any) => {
      return {
        ...x,
        disabled: x.selected,
      };
    });
    this.componenetListItems = componentListItems;
  }

  ngOnDestroy() {
    this.searchSubject.complete();
    this.projectFacde.clearaddTransportScenarioForPackMaterialForConversion();
    this.reuseComponentsItemSubscription.unsubscribe();
    this.subscriptionProjectPreRetailData.unsubscribe();
    this.subscriptionProjectPreRetailManudalDistanceData.unsubscribe();
    this.subscriptionSaveProjectManualDistanceEOLData.unsubscribe();
    this.clearInputFieldProjectRetailManualDistanceEOL.unsubscribe();
    this.reuseComponentsItemSubscription.unsubscribe();
    this.editReuseProcessItemSubscription.unsubscribe();
    this.saveReuseProcessItemSubscription.unsubscribe();
    this.reuseDeleteComponentsItemSubscription.unsubscribe();
  }
}
